import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    CODES: 'codes',
    CODE_SYSTEMS: 'code-systems',
    CONCEPTS: 'concepts',
    LIST: 'list',
    LISTS: 'lists',
    VALUE_SETS: 'value-sets'
};

export const MUTATION_KEYS = {
    LIST: 'list',
    LIST_ITEM: 'list-item'
};
